import * as React from "react";
import InformationList from "../components/Information";
import SlideShow from "../components/SlideShow";
import {MobileMedia, PCMedia} from "../components/Media";
import ConsultationTable from "../components/ConsultationTable";
import Links from "../components/Links";

const IndexPage : React.FC = () => {
    return (
        <React.Fragment>
            <div>
                <img src={"/images/headerpic2.png"} className={"header"} alt={"通院で直せる痔の治療 宮岡クリニックでは、専門性を生かし、胃、大腸、肛門の治療に特に力を注いでいます。"}/>
            </div>
            <MobileMedia>
                <div className={"clinic-hours-mobile"}>
                    <h1>診察時間</h1>
                    <ConsultationTable isMobile={true}/>
                </div>
                <div className={"shortcut"}>
                    <a href={"/access.html"}>
                        <img src="/images/access.svg" width={50} height={50}/>
                        <div>アクセス</div>
                    </a>
                    <a href={"https://goo.gl/maps/uLGBZRxcgv5u8cE2A"} target={"_blank"}>
                        <img src="/images/map.svg" width={50} height={50}/>
                        <div>マップ</div>
                    </a>
                    <a href={"tel:06-6571-3506"}>
                        <img src="/images/tel.svg" width={50} height={50}/>
                        <div className={"small"}>内視鏡の<br/>ご予約</div>
                    </a>
                </div>
            </MobileMedia>
            <InformationList/>
            <div className={"index-others"}>
                <h1>診療科目</h1>
                <h2>外科・内科・胃腸科・肛門科・麻酔科</h2>
                <p>名誉院長：宮岡哲郎（みやおか　てつろう）</p>
                <p>院長：宮岡雄太（みやおか　ゆうた）</p>
                <h2>診療内容</h2>
                <ul>
                    <li>生活習慣病（高血圧・糖尿病・高脂血症等）</li>
                    <li>内視鏡検査
                        <ul>
                            <li>胃内視鏡（胃カメラ）</li>
                            <li>大腸内視鏡（大腸カメラ）</li>
                            <li>ポリープ切除（日帰り）</li>
                        </ul>
                    </li>
                    <li>痔の治療
                        <ul>
                            <li><a href={"/zion.html"}>ジオン注(ALTA療法)</a>による内痔核硬化療法</li>
                            <li>シートン法による痔ろう根治術</li>
                            <li>結紮による外痔核の切除</li>
                            <li>肛門の拡張術</li>
                        </ul>
                    </li>
                    <li>レントゲン検査</li>
                    <li>腹部超音波検査</li>
                    <li>骨粗鬆症診断（骨塩定量検査）</li>
                    <li>大阪市市民健診（基本健診・胃がん健診等）</li>
                    <li>予防接種（各種予防接種）</li>
                    <li>薬剤師によるお薬相談（お薬全般について）</li>
                </ul>
                <p>
                    ピロリ菌の診断および除菌治療（尿素呼気試験）<br/>
                    日帰り手術（肛門疾患：痔瘻、いぼ痔、切れ痔、脱肛など<br/>
                    皮膚腫瘍切除、膿瘍切開）外傷<br/>
                </p>
                <h2>医療情報の活用について</h2>
                <p>
                    当院は質の高い診療を実施するため、オンライン資格確認や電子処方箋のデータ等から取得する情報を活用して診療をおこなっています。
                </p>
                <h2>健康相談及び予防接種に係る相談を実施しています</h2>
                <p>
                    介護支援専門員及び相談支援専門員からの相談にも対応しております。<br/>
                    また介護保険の相談も承っております。<br/>
                    当院では、28日以上の長期の投薬を行うことやリフィル処方箋を交付することが可能です。<br/>
                    ※但し病状によりお断りする可能性があります。
                </p>
            </div>
            <SlideShow/>
            <MobileMedia>
                <div className={"other-menu"}>
                    <h1>その他メニュー</h1>
                    <a href={"/intyou.html"}>
                        医師紹介
                    </a>
                    <a href={"/setubi.html"}>
                        設備案内
                    </a>
                    <a href={"/lifestyle.html"}>
                        生活習慣病
                    </a>
                    <a href={"/gan.html"}>
                        癌の早期発見
                    </a>
                    <a href={"/zion.html"}>
                        ジオン注(痔核治療)
                    </a>
                </div>
                <div className={"link-mobile"}>
                    <h1>リンク</h1>
                    <Links/>
                </div>
            </MobileMedia>
        </React.Fragment>
    );
}

export default IndexPage;
